// import { useParams } from 'react-router-dom';
// import { useEffect, useState,useContext } from 'react';
// import axios from 'axios';
// import ArrowBackIosNewIcon from "@mui/icons-material/ArrowBackIosNew";
// import { BASE_URL } from './../../Api/ApiUrls';
// import React from 'react';
// import { AuthContext } from "./../../AuthContext/AuthContext";
// import { useNavigate } from 'react-router-dom';
// import {
//   Box,
//   Container,
//   AppBar,
//   Toolbar,
//   IconButton,
//   Typography,
//   Card,
//   CardContent,
//   CircularProgress,
//   Avatar
// } from '@mui/material';
// import FormsBottomNavbar from "./../Post Module/FormsBottomNavbar";
// import VisibilityIcon from '@mui/icons-material/Visibility';

// function ViewListPage() {
//   const { propertyId } = useParams();
//   const [viewers, setViewers] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [propertyDetails, setPropertyDetails] = useState(null);
//   const navigate = useNavigate();
//     const { userId } = useContext(AuthContext);
//   const maskPhoneNumber = (phone) => {
//     if (!phone) return "N/A";
//     const lastThree = phone.slice(-3); 
//     return `XXX XXXX ${lastThree}`;
//   };

//   // useEffect(() => {
//   //   const fetchViewers = async () => {
//   //     try {
//   //       // Fetch property details first
//   //       const propertyResponse = await axios.get(`${BASE_URL}/property/`);
//   //       const property = propertyResponse.data.find(
//   //         item => item.property_id == propertyId
//   //       );
//   //       setPropertyDetails(property);

//   //       // Fetch all activities
//   //       const response = await axios.get(`${BASE_URL}/activities/`);
        
//   //       // Filter activities for this property with "Description" type
//   //       const propertyViews = response.data.filter(activity => 
//   //         activity.property_id == propertyId && 
//   //         activity.activity_type === "Description"
//   //       );
        
//   //       // Get user details for each viewer
//   //       const viewersWithDetails = await Promise.all(
//   //         propertyViews.map(async (view) => {
//   //           try {
//   //             const userResponse = await axios.get(`${BASE_URL}/users/${view.user_id}/`);
//   //             return {
//   //               ...view,
//   //               userDetails: userResponse.data
//   //             };
//   //           } catch (error) {
//   //             console.error(`Error fetching user ${view.user_id}:`, error);
//   //             return {
//   //               ...view,
//   //               userDetails: { username: "Unknown User" }
//   //             };
//   //           }
//   //         })
//   //       );
        
//   //       setViewers(viewersWithDetails);
//   //     } catch (error) {
//   //       console.error('Error fetching viewers:', error);
//   //     } finally {
//   //       setLoading(false);
//   //     }
//   //   };

//   //   fetchViewers();
//   // }, [propertyId]);

// useEffect(() => {
//   const fetchViewers = async () => {
//     try {
//       setLoading(true);

//       // Fetch all activities
//       const response = await axios.get(`${BASE_URL}/activities/`);

//       // Filter property views
//       const propertyViews = response.data.filter(
//         activity =>
//           activity.property_id == propertyId &&
//           activity.activity_type === "Description" &&
//           activity.user_id !== userId
//       );

//       // Remove duplicate users
//       const uniqueViews = [
//         ...new Map(
//           propertyViews.map(item => [item.user_id, item])
//         ).values()
//       ];

//       // Fetch user details
//       const viewersWithDetails = await Promise.all(
//         uniqueViews.map(async (view) => {
//           try {
//             const userResponse = await axios.get(
//               `${BASE_URL}/users/${view.user_id}/`
//             );

//             return {
//               ...view,
//               userDetails: userResponse.data,
//             };
//           } catch (error) {
//             console.error(
//               `Error fetching user ${view.user_id}:`,
//               error
//             );

//             return {
//               ...view,
//               userDetails: {
//                 username: "Unknown User",
//                 mobile_no: "",
//               },
//             };
//           }
//         })
//       );

//       setViewers(viewersWithDetails);
//     } catch (error) {
//       console.error("Error fetching viewers:", error);
//     } finally {
//       setLoading(false);
//     }
//   };

//   fetchViewers();
// }, [propertyId, userId]);

//   if (loading) {
//     return (
//       <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
//         <CircularProgress />
//       </Box>
//     );
//   }

//   return (
//    <Box
//   sx={{
//     display: "flex",
//     flexDirection: "column",
//     minHeight: "100vh",
//     background: `
//       linear-gradient(145deg, rgba(232,224,208,0.95), rgba(216,204,186,0.95)),
//       url('/construction4.png')
//     `,
//     backgroundSize: "cover",
//     backgroundAttachment: "fixed"
//   }}
// >
//       {/* Header */}
//       <AppBar 
//         position="fixed"
//         elevation={0}
//              sx={{ 
//             top: 0,
//             left: 0,
//             right: 0,
//             zIndex: 1200, // Added zIndex
//           background: `
//             linear-gradient(145deg,rgb(22, 22, 22),rgb(15, 15, 15)),
//             url('/construction5.png')
//           `,
//           color: 'text.primary',
//           boxShadow: '0 2px 10px rgba(0,0,0,0.1)'
//         }}
//       >
//         <Toolbar sx={{ minHeight: 64 }}>
//           <IconButton 
//             edge="start" 
//             onClick={() => navigate(-1)}
//             sx={{ 
//               color: '#ffffff',
//               backgroundColor: 'rgba(255,255,255,0.1)',
//               '&:hover': { 
//                 backgroundColor: 'rgba(255,255,255,0.2)' 
//               }
//             }}
//           >
//             <ArrowBackIosNewIcon />
//           </IconButton>
//           <Typography variant="h6" sx={{ flexGrow: 1, ml: 2, color: 'white', fontSize: { xs: '0.9rem', sm: '1.25rem' } }}>
//             Property ID: {propertyId} Viewers
//           </Typography>
//         </Toolbar>
//       </AppBar>

//       {/* Main Content - Scrollable Area */}
// <Container
//   sx={{
//     py: 3,
//     mt: "64px",   // Correct header space
//     mb: "80px",   // Space for bottom navbar
//     overflowY: "auto",

//   }}
// >
    
//         <Card sx={{ borderRadius: '12px', overflow: 'hidden', boxShadow: 3, }}>
//           <Typography
//             variant="h6"
//             align="center"
//             sx={{ 
//               p: 2, 
//               backgroundColor: '#f5f5f5', 
//               fontWeight: 'bold',
//               fontSize: { xs: '1.0rem', sm: '1.25rem' }
//             }}
//           >
//             Property Viewers
//           </Typography>

//           <CardContent>
//             {viewers.length > 0 ? (
//               <Box display="flex" flexDirection="column" gap={2}>
//                 {viewers.map((view, index) => (
//                   <Card
//                     key={view.log_id || index}
//                     sx={{
//                       p: 2,
//                       borderRadius: 3,
//                       boxShadow: 2,
//                       backgroundColor: '#fff',
//                     }}
//                   >
//                     <Box display="flex" justifyContent="flex-end" alignItems="center">
//                       <Box
//                         sx={{
//                           backgroundColor: '#e3f2fd',
//                           color: '#1565c0',
//                           px: 1.5,
//                           py: 0.5,
//                           borderRadius: 2,
//                           fontSize: '10px',
//                           fontWeight: 500,
//                           display: 'inline-block'
//                         }}
//                       >
//                         Viewed Property
//                       </Box>
//                     </Box>

//                     <Box display="flex" justifyContent="space-between" alignItems="center">
//                       <Box display="flex" alignItems="center">
//                         <Avatar 
//                           sx={{ 
//                             bgcolor: '#1976d2', 
//                             mr: 2,
//                             width: 40, 
//                             height: 40 
//                           }}
//                         >
//                           {view.userDetails?.username?.charAt(0)?.toUpperCase() || 'U'}
//                         </Avatar>
//                         <Box>
//                           <Typography variant="subtitle1" sx={{ fontWeight: 'bold', fontSize: '0.8rem' }}>
//                             {view.userDetails?.username || "Unknown User"}
//                           </Typography>

//                           <Typography variant="body2" color="text.secondary" sx={{ fontSize: '0.7rem' }}>
//                             CUSTOMER: {String(view.user_id).padStart(4, "0")}
//                           </Typography>

//                           {view.userDetails?.mobile_no && (
//                             <Typography variant="body2" color="text.secondary" sx={{ fontSize: '0.7rem' }}>
//                               PHONE: {maskPhoneNumber(view.userDetails.mobile_no)}
//                             </Typography>
//                           )}
//                         </Box>
//                       </Box>
//                     </Box>
//                   </Card>
//                 ))}
//               </Box>
//             ) : (
//               <Box sx={{ textAlign: 'center', py: 4 }}>
//                 <VisibilityIcon sx={{ fontSize: 60, color: '#bdbdbd', mb: 2 }} />
//                 <Typography variant="h6" color="text.secondary" sx={{ fontSize: { xs: '1rem', sm: '1.25rem' } }}>
//                   No users have viewed this property yet
//                 </Typography>
//                 <Typography variant="body2" color="text.secondary" sx={{ mt: 1, fontSize: '0.875rem' }}>
//                   When users view your property, they will appear here.
//                 </Typography>
//               </Box>
//             )}
//           </CardContent>
//         </Card>
//       </Container>

//       {/* Bottom Navigation */}
//       <Box sx={{ position: "fixed", bottom: 0, left: 0, right: 0 }}>
//         <FormsBottomNavbar /> 
//       </Box>
//     </Box>
//   );
// }

// export default ViewListPage;


import { useParams, useNavigate } from 'react-router-dom';
import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { BASE_URL } from './../../Api/ApiUrls';
import {
  Box,
  Container,
  AppBar,
  Toolbar,
  IconButton,
  Typography,
  Card,
  CircularProgress,
  Avatar,
  Badge,
  Dialog,
  Button,
} from '@mui/material';

import FormsBottomNavbar from './../Post Module/FormsBottomNavbar';
import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew';
import NotificationsRoundedIcon from '@mui/icons-material/NotificationsRounded';
import PhoneRoundedIcon from '@mui/icons-material/PhoneRounded';
import LocationOnRoundedIcon from '@mui/icons-material/LocationOnRounded';
import ChatBubbleRoundedIcon from '@mui/icons-material/ChatBubbleRounded';
import FavoriteRoundedIcon from '@mui/icons-material/FavoriteRounded';
import VisibilityRoundedIcon from '@mui/icons-material/VisibilityRounded';
import WhatsAppIcon from '@mui/icons-material/WhatsApp';
import FileCopyOutlinedIcon from '@mui/icons-material/FileCopyOutlined';

// ── Palette ──
const TITLE_DARK = '#3B0A0A';
const BROWN = '#7A3E1D';
const CARD_BG = '#FDEFE3';
const CARD_BORDER = '#F3DCC6';
const SUBTLE = '#7A6A5A';
const GREEN = '#25A244';

// ── activity_type → notification config ──
const ACTIVITY_CONFIG = {
  Call: {
    title: 'Contact Details Shared',
    message: 'Contact details have been shared with the owner.',
    Icon: PhoneRoundedIcon,
  },
  Location: {
    title: 'Property Location Shared',
    message: 'The property location has been viewed on map.',
    Icon: LocationOnRoundedIcon,
  },
  Chat: {
    title: 'Chat Available',
    message: 'Started a chat with the owner on Property Pincoder.',
    Icon: ChatBubbleRoundedIcon,
  },
  Liked: {
    title: 'Added to Wishlist',
    message: 'This property has been added to the Wishlist.',
    Icon: FavoriteRoundedIcon,
  },
  Description: {
    title: 'Property Viewed',
    message: 'The property details have been viewed.',
    Icon: VisibilityRoundedIcon,
  },
};

const timeAgo = (dateStr) => {
  const diff = Math.max(0, Date.now() - new Date(dateStr).getTime());
  const mins = Math.floor(diff / 60000);
  if (mins < 1) return 'Just now';
  if (mins < 60) return `${mins} min${mins > 1 ? 's' : ''} ago`;
  const hrs = Math.floor(mins / 60);
  if (hrs < 24) return `${hrs} hr${hrs > 1 ? 's' : ''} ago`;
  const days = Math.floor(hrs / 24);
  return `${days} day${days > 1 ? 's' : ''} ago`;
};

const maskPhone = (phone) => {
  if (!phone) return 'N/A';

  const digits = String(phone).replace(/\D/g, '').slice(-10);

  if (digits.length < 10) return phone;

  return `+91 ${digits.slice(0, 5)} XXXXX`;
};

const isNew = (dateStr) => Date.now() - new Date(dateStr).getTime() < 60 * 60 * 1000;

const formatPhone = (phone) => {
  if (!phone) return 'N/A';
  const digits = String(phone).replace(/\D/g, '').slice(-10);
  if (digits.length < 10) return phone;
  return `+91 ${digits.slice(0, 5)} ${digits.slice(5)}`;
};

function ViewListPage() { 
  const { propertyId } = useParams();
  const navigate = useNavigate();
  const [notifications, setNotifications] = useState([]);
  const [users, setUsers] = useState({}); // { [user_id]: userDetails }
  const [loading, setLoading] = useState(true);
  const [copiedNumber, setCopiedNumber] = useState('');
  const [copyOpen, setCopyOpen] = useState(false);

  const handleCopyPhone = async (rawPhone) => {
    if (!rawPhone) return;
    const number = String(rawPhone).replace(/\D/g, '').slice(-10);
    try {
      if (navigator.clipboard && window.isSecureContext) {
        await navigator.clipboard.writeText(number);
      } else {
        // Fallback for non-secure contexts / older browsers
        const ta = document.createElement('textarea');
        ta.value = number;
        ta.style.position = 'fixed';
        ta.style.opacity = '0';
        document.body.appendChild(ta);
        ta.select();
        document.execCommand('copy');
        document.body.removeChild(ta);
      }
      setCopiedNumber(number);
      setCopyOpen(true);
    } catch (err) {
      console.error('Copy failed:', err);
    }
  };

  useEffect(() => {
    const fetchNotifications = async () => {
      try {
        setLoading(true);

        const response = await axios.get(`${BASE_URL}/activities/`, {
          params: { property_id: propertyId },
        });

        const list = (Array.isArray(response.data.data) ? response.data.data : [])
          .filter((a) => ACTIVITY_CONFIG[a.activity_type])
          .sort((a, b) => new Date(b.created_at) - new Date(a.created_at));

        setNotifications(list);

        // Fetch details for EACH distinct user who did an activity
        const uniqueUserIds = [...new Set(list.map((a) => a.user_id))];

        const entries = await Promise.all(
          uniqueUserIds.map(async (id) => {
            try {
              const res = await axios.get(`${BASE_URL}/users/${id}/`);
              return [id, res.data];
            } catch (err) {
              console.error(`Error fetching user ${id}:`, err);
              return [id, { username: 'Unknown User', mobile_no: '' }];
            }
          })
        );

        setUsers(Object.fromEntries(entries));
      } catch (error) {
        console.error('Error fetching notifications:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchNotifications();
  }, [propertyId]);

  if (loading) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
        <CircularProgress />
      </Box>
    );
  }

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        minHeight: '100vh',
        width: '100%',
        overflowX: 'hidden',
        background: `
          linear-gradient(145deg, rgba(232,224,208,0.95), rgba(216,204,186,0.95)),
          url('/construction4.png')
        `,
        backgroundSize: 'cover',
        backgroundAttachment: 'fixed',
      }}
    >
      {/* ===== HEADER ===== */}
      <AppBar
        position="fixed"
        elevation={0}
        sx={{
          top: 0,
          left: 0,
          right: 0,
          zIndex: 1200,
          background: `
            linear-gradient(145deg,rgb(22, 22, 22),rgb(15, 15, 15)),
            url('/construction5.png')
          `,
          color: 'text.primary',
          boxShadow: '0 2px 10px rgba(0,0,0,0.1)',
        }}
      >
        <Toolbar sx={{ minHeight: 64 }}>
          <IconButton
            edge="start"
            onClick={() => navigate(-1)}
            sx={{
              color: '#ffffff',
              backgroundColor: 'rgba(255,255,255,0.1)',
              '&:hover': { backgroundColor: 'rgba(255,255,255,0.2)' },
            }}
          >
            <ArrowBackIosNewIcon />
          </IconButton>
          <Typography
            variant="h6"
            sx={{ flexGrow: 1, ml: 2, color: 'white', fontSize: { xs: '0.9rem', sm: '1.25rem' } }}
          >
            Property ID: {propertyId} Viewers
          </Typography>
        </Toolbar>
      </AppBar>

      {/* ===== MAIN CONTENT ===== */}
      <Container
        disableGutters
        sx={{
          pt: 2,
          px: { xs: 1, sm: 2 },
          mt: '64px',
          mb: '90px',
          maxWidth: '520px !important',
          width: '100%',
        }}
      >
        <Box
          sx={{
            borderRadius: '18px',
            background: '#FFFFFF',
            boxShadow: '0 6px 20px rgba(0,0,0,0.10)',
            p: { xs: 1.2, sm: 2 },
          }}
        >
          {/* ── Card header ── */}
          <Box sx={{ display: 'flex', alignItems: 'center', gap: { xs: 1, sm: 1.5 }, mb: 1.5 }}>
            <Badge
              badgeContent={notifications.length}
              color="error"
              overlap="circular"
              sx={{
                '& .MuiBadge-badge': { fontWeight: 700, fontSize: '0.62rem', minWidth: 16, height: 16 },
              }}
            >
              <Avatar
                sx={{
                  width: { xs: 40, sm: 52 },
                  height: { xs: 40, sm: 52 },
                  bgcolor: CARD_BG,
                  color: BROWN,
                }}
              >
                <NotificationsRoundedIcon sx={{ fontSize: { xs: 22, sm: 28 } }} />
              </Avatar>
            </Badge>

            <Box sx={{ flex: 1, minWidth: 0 }}>
              <Typography
                sx={{
                  fontWeight: 800,
                  fontSize: { xs: '1rem', sm: '1.2rem' },
                  color: TITLE_DARK,
                  lineHeight: 1.2,
                }}
              >
                All Notifications
              </Typography>
              <Typography sx={{ fontSize: { xs: '0.66rem', sm: '0.76rem' }, color: SUBTLE, lineHeight: 1.25 }}>
                Here are your recent updates. All details are shown below.
              </Typography>
            </Box>
          </Box>

          {/* ── List ── */}
          {notifications.length > 0 ? (
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: { xs: 1, sm: 1.4 } }}>
              {notifications.map((n, index) => {
                const cfg = ACTIVITY_CONFIG[n.activity_type];
                const { Icon } = cfg;

                const user = users[n.user_id] || {};
                const name = user.username || 'Unknown User';
               const isDescription = n.activity_type === 'Description';

const phone = isDescription
  ? maskPhone(user.mobile_no)
  : formatPhone(user.mobile_no);

                return (
                  <Card
                    key={n.log_id || index}
                    elevation={0}
                    sx={{
                      p: { xs: 1, sm: 1.4 },
                      borderRadius: '14px',
                      background: CARD_BG,
                      border: `1px solid ${CARD_BORDER}`,
                      display: 'flex',
                      flexDirection: 'column',
                      gap: 0.8,
                      overflow: 'hidden',
                    }}
                  >
                    {/* Top row: icon + title/time + message */}
                    <Box sx={{ display: 'flex', alignItems: 'flex-start', gap: { xs: 1, sm: 1.3 } }}>
                      <Avatar
                        sx={{
                          width: { xs: 34, sm: 44 },
                          height: { xs: 34, sm: 44 },
                          bgcolor: '#F9DCC4',
                          color: BROWN,
                          flexShrink: 0,
                        }}
                      >
                        <Icon sx={{ fontSize: { xs: 18, sm: 24 } }} />
                      </Avatar>

                      <Box sx={{ flex: 1, minWidth: 0 }}>
                        <Box
                          sx={{
                            display: 'flex',
                            justifyContent: 'space-between',
                            alignItems: 'center',
                            gap: 0.6,
                          }}
                        >
                          <Typography
                            sx={{
                              fontWeight: 800,
                              fontSize: { xs: '0.85rem', sm: '1rem' },
                              color: TITLE_DARK,
                              lineHeight: 1.2,
                              flex: 1,
                              minWidth: 0,
                            }}
                          >
                            {cfg.title}
                          </Typography>

                          <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5, flexShrink: 0 }}>
                            <Typography
                              sx={{
                                fontSize: { xs: '0.58rem', sm: '0.68rem' },
                                color: SUBTLE,
                                whiteSpace: 'nowrap',
                              }}
                            >
                              {timeAgo(n.created_at)}
                            </Typography>
                            {isNew(n.created_at) && (
                              <Box
                                sx={{
                                  bgcolor: '#E53935',
                                  color: '#fff',
                                  fontSize: '0.54rem',
                                  fontWeight: 800,
                                  px: 0.7,
                                  py: 0.05,
                                  borderRadius: '999px',
                                }}
                              >
                                NEW
                              </Box>
                            )}
                          </Box>
                        </Box>

                        <Typography
                          sx={{
                            fontSize: { xs: '0.66rem', sm: '0.76rem' },
                            color: SUBTLE,
                            mt: 0.2,
                            lineHeight: 1.3,
                          }}
                        >
                          {cfg.message}
                        </Typography>
                      </Box>
                    </Box>

                    {/* User row — full card width so the phone is never clipped */}
                    <Box
                      sx={{
                        p: { xs: 0.7, sm: 0.9 },
                        bgcolor: '#fff',
                        borderRadius: '10px',
                        display: 'flex',
                        alignItems: 'center',
                        flexWrap: 'wrap',
                        columnGap: 1,
                        rowGap: 0.5,
                      }}
                    >
                      <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.8, minWidth: 0, flex: '1 1 auto' }}>
                        <Avatar
                          sx={{
                            width: { xs: 26, sm: 32 },
                            height: { xs: 26, sm: 32 },
                            bgcolor: '#7A4A2B',
                            fontSize: { xs: '0.72rem', sm: '0.85rem' },
                            flexShrink: 0,
                          }}
                        >
                          {name.charAt(0).toUpperCase()}
                        </Avatar>

                       <Box sx={{ minWidth: 0, flex: 1 }}>
                         <Typography
  sx={{
    fontWeight: 700,
    fontSize: { xs: '0.7rem', sm: '0.8rem' },
    color: TITLE_DARK,
    lineHeight: 1.15,
    whiteSpace: 'normal',
    wordBreak: 'break-word',
  }}
>
  {name}
</Typography>
                        </Box>
                      </Box>

                     <Box
  onClick={() => {
    if (!isDescription) {
      handleCopyPhone(user.mobile_no);
    }
  }}
  role={!isDescription ? 'button' : undefined}
  tabIndex={!isDescription ? 0 : undefined}
  onKeyDown={(e) => {
    if (
      !isDescription &&
      (e.key === 'Enter' || e.key === ' ')
    ) {
      e.preventDefault();
      handleCopyPhone(user.mobile_no);
    }
  }}
  sx={{
    display: 'flex',
    alignItems: 'center',
    gap: 0.4,
    flexShrink: 0,
    pl: 1,
    borderLeft: '1px solid #E5DACB',
    cursor: !isDescription && user.mobile_no
      ? 'pointer'
      : 'default',
    WebkitTapHighlightColor: 'transparent',
    '&:active': {
      opacity: !isDescription ? 0.6 : 1,
    },
  }}
>
  <WhatsAppIcon
    sx={{
      fontSize: { xs: 16, sm: 20 },
      color: GREEN,
    }}
  />

  <Typography
    sx={{
      fontWeight: 700,
      fontSize: { xs: '0.7rem', sm: '0.8rem' },
      color: TITLE_DARK,
      whiteSpace: 'nowrap',
    }}
  >
    {phone}
  </Typography>
</Box>
                    </Box>
                  </Card>
                );
              })}
            </Box>
          ) : (
            <Box sx={{ textAlign: 'center', py: 5 }}>
              <NotificationsRoundedIcon sx={{ fontSize: 56, color: '#bdbdbd', mb: 1 }} />
              <Typography color="text.secondary" sx={{ fontSize: '0.9rem' }}>
                No notifications yet
              </Typography>
            </Box>
          )}
        </Box>
      </Container>

      {/* ===== COPIED POPUP ===== */}
      <Dialog
        open={copyOpen}
        onClose={() => setCopyOpen(false)}
        PaperProps={{
          sx: {
            borderRadius: '22px',
            width: '100%',
            maxWidth: 300,
            m: 2,
            px: { xs: 2.5, sm: 3 },
            pt: 3.5,
            pb: 3,
            textAlign: 'center',
          },
        }}
      >
        <FileCopyOutlinedIcon sx={{ fontSize: 64, color: '#2E7D32', alignSelf: 'center' }} />
        <Typography sx={{ fontWeight: 800, fontSize: '1.15rem', color: '#1b1b1b', mt: 1.5 }}>
          Copied Successfully
        </Typography>
        <Typography sx={{ fontSize: '0.85rem', color: '#6b6b6b', mt: 1 }}>
          Copied: {copiedNumber}
        </Typography>
        <Button
          fullWidth
          variant="contained"
          onClick={() => setCopyOpen(false)}
          sx={{
            mt: 3,
            py: 1.1,
            borderRadius: '14px',
            textTransform: 'none',
            fontWeight: 800,
            fontSize: '1rem',
            bgcolor: '#2E7D32',
            boxShadow: '0 4px 10px rgba(46,125,50,0.35)',
            '&:hover': { bgcolor: '#27692a' },
          }}
        >
          OK
        </Button>
      </Dialog>

      {/* ===== BOTTOM NAV ===== */}
      <Box sx={{ position: 'fixed', bottom: 0, left: 0, right: 0 }}>
        <FormsBottomNavbar />
      </Box>
    </Box>
  );
}

export default ViewListPage;